import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {ToggleTo} from './toggle-to';
import {Observable} from 'rxjs';
import {FeatureToggle} from './feature-toggle';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ToggleService {

  static baseUrl = `${environment.baseUrl}/toggles`;

  constructor(private httpClient: HttpClient) {
  }

  getToggle(featureToggle: FeatureToggle): Observable<ToggleTo> {
    return this.httpClient.get<ToggleTo>(`${ToggleService.baseUrl}/${featureToggle}`);
  }

  active(featureToggle: FeatureToggle): Observable<boolean> {
    return this.httpClient.get<boolean>(`${ToggleService.baseUrl}/active/${featureToggle}`);
  }
}
